import { Record } from 'immutable';

interface LiveStreamHistoryInterface {
  nameFilter: string | null;
}

export const initialState: LiveStreamHistoryInterface = {
  nameFilter: null
};

export class LiveStreamHistoryState extends Record(initialState) {
}
